import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import NotificationProvider from '../providers/NotificationProvider';
import ScrollToTop from '../components/common/ScrollToTop';
import CanonicalLink from '../components/CanonicalLink';

const Router = () => {
  return (
    <BrowserRouter>
      <NotificationProvider>
        <ScrollToTop>
          <CanonicalLink />
          <Routes />
        </ScrollToTop>
      </NotificationProvider>
    </BrowserRouter>
  );
};

export default Router;
